"use strict";
import React from "react";

const initComponent = (flex = window.flex) => {

    class ContentModal extends React.PureComponent {
        handleOnClick = (e) => {
            const props = this.props || {};
            var request = { types: props.types };

            $.ajax({
                url: flex.getApiUrl("/api/v1/post/getsitecontent"),
                async: true,
                type: "post",
                dataType: "json",
                contentType: "application/json",
                data: JSON.stringify(request),
                headers: flex.getHeaders(),
                success: function (data) {
                    let displayContent = [];
                    data.siteContent.map(function (content) {
                        displayContent.push({ summary: content.content });
                    })

                    flex.addPageModalContent(displayContent);
                },
                error: function (jqXHR, textStatus, errorThrown) {
                    flex.handleAjaxError(jqXHR, textStatus, errorThrown);
                    flex.setStore({ error: errorThrown });
                }
            });
        };

        render() {
            const props = this.props || {};
            const children = React.cloneElement(props.children, { onClick: this.handleOnClick });
            return (<span>{children}</span>
            );
        }
    }

    return ContentModal;
};

module.exports = initComponent;
